module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"street1":"Address","street2":"Apt/Suite/Other","locality":"City","region":"State","postalCode":"Zip code","addAddress":"Add an address","addAddressOptions":{"shippingAddress":"Shipping address","billingAddress":"Billing address","otherAddress":"Optional address"}}}')
  delete Component.options._Ctor
}
